import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom'; // Import Navigate
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import AlumniDirectory from './pages/AlumniDirectory';
import JobPortal from './pages/JobPortal';
import Events from './pages/Event';
import Donation from './pages/Donation';
import Contact from './pages/Contact';
import SidebarLayout from './pages/SidebarLayOut'; // Import the new layout component
import AlumniProfile from './pages/AlumniProfile'; // Import AlumniProfile
import './App.css';
import AluminiRegistration from "./components/Registration/AluminiRegistration";
import StudentRegistration from "./components/Registration/StudentRegistration";
import CollegeRegistration from "./components/Registration/CollegeRegistration";
import Login from "./components/Login";
import Register from './components/Register';
import AlumniProfileFeed from './pages/AlumniProfileFeed';

function App() {
  const location = useLocation(); // useLocation is now inside the Router context

  const shouldHideNavbarAndFooter = 
    location.pathname === '/alumnidirectory' || 
    location.pathname === '/alumprofile' ||
    location.pathname === '/feed';

  return (
    <>
      {!shouldHideNavbarAndFooter && <Navbar />}
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Redirect Alumni Directory to Alumni Profile */}
          <Route 
            path="/alumnidirectory" 
            element={<Navigate to="/feed" replace />} 
          />
          <Route path="/jobportal" element={<JobPortal />} />
          <Route path="/events" element={<Events />} />
          <Route path="/donation" element={<Donation />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/register-alumni" element={<AluminiRegistration />} />
          <Route path="/register-college" element={<CollegeRegistration />} />
          <Route path="/register-student" element={<StudentRegistration />} />

          {/* Sidebar layout for profile and feed pages */}
          <Route element={<SidebarLayout />}>
            <Route path="/alumprofile" element={<AlumniProfile />} /> 
            <Route path="/feed" element={<AlumniProfileFeed />} /> 
          </Route>
          <Route path="/signin" element={<Login />} /> 
          <Route path="/register" element={<Register />} /> 
        </Routes>
      </div>
      {!shouldHideNavbarAndFooter && <Footer />}
    </>
  );
}

export default App;
